module.exports = __webpack_public_path__ + "assets/img/db36-tt.svg";